/**
 * Entry application component used to compose providers and render Routes.
 * */

import { LicenseInfo } from '@mui/x-license-pro';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ReduxToastr from 'react-redux-toastr';
import TwoLevelSnackbar from '../_oi/helpers/SnackbarsCustom/TwoLevelSnackbar';
import UnauthorizedSnackbar from '../_oi/helpers/SnackbarsCustom/UnauthorizedSnackbar';
import WrongParamsSnackbar from '../_oi/helpers/SnackbarsCustom/WrongParamsSnackbar';
//import { Routes } from "../app/Routes";
import { MaterialThemeProvider } from '../_oi/layout/theme';
import { Root } from './routes/Routes';

LicenseInfo.setLicenseKey(
     '2776bf21dac1548d2cf524265207d3a2Tz0xMDUzMTIsRT0xNzY3OTE2Nzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'
);

export default function App({ pca }) {
     return (
          <MaterialThemeProvider>
               {/* Render routes with provided `Layout`. <Routes />*/}
               <ReduxToastr
                    timeOut={0}
                    newestOnTop={true}
                    preventDuplicates
                    position="top-right"
                    getState={(state) => state.toastr} // This is the default
                    transitionIn="bounceIn"
                    transitionOut="bounceOut"
                    progressBar={false}
                    attention={true}
                    closeOnToastrClick
               />
               <SnackbarProvider
                    // TransitionComponent={Grow}
                    anchorOrigin={{
                         horizontal: 'right',
                         vertical: 'top',
                    }}
                    autoHideDuration={null}
                    preventDuplicate={true}
                    Components={{
                         WrongParamsSnackbar: WrongParamsSnackbar,
                         UnauthorizedSnackbar: UnauthorizedSnackbar,
                         TwoLevelSnackbar: TwoLevelSnackbar,
                    }}
               >
                    <Root />
               </SnackbarProvider>
          </MaterialThemeProvider>
     );
}
